import { render, staticRenderFns } from "./MisClientes.vue?vue&type=template&id=601eb193&scoped=true"
import script from "./MisClientes.vue?vue&type=script&lang=js"
export * from "./MisClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601eb193",
  null
  
)

export default component.exports